
import { TransferAssetApproverTypeInfoBase } from './transfer-asset-approver.typeinfo.base';


export class TransferAssetApproverTypeInfo extends TransferAssetApproverTypeInfoBase {
}

export const TRANSFER_ASSET_APPROVER_TYPE: TransferAssetApproverTypeInfo = new TransferAssetApproverTypeInfo();



